import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/index.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        meta: {
            keepAlive: false,
            isBack: false,
        },
        component: login
    },
    {
        path: '/china',
        name: 'Home',
        meta: {
            keepAlive: false,
            isBack: false,
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/chinaIndex.vue')
    },
    {
        path: '/carbon',
        name: 'carbon',
        meta: {
            keepAlive: true, // 需要被缓存
            isBack: false,
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/index.vue')
    },
    {
        path: '/chinaCarbon',
        name: 'carbon',
        meta: {
            keepAlive: true, // 需要被缓存
            isBack: false,
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/chinaIndex.vue')
    },

    {
        path: '/carbonDetail',
        name: 'Detail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/detail.vue')
    },

    {
        path: '/accountDetail',
        name: 'Detail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/accountDetail.vue')
    },

    {
        path: '/approval',
        name: 'Detail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/approval.vue')
    },
    {
        path: '/approvalDetail',
        name: 'Detail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/approvalDetail.vue')
    },
    {
        path: '/carbonDetail2',
        name: 'Detail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/detail2.vue')
    },
    {
        path: '/nfdtDetail',
        name: 'nfdtDetail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/nfdtDetail.vue')
    },
    {
        path: '/nfdtHashDetail',
        name: 'nfdtHashDetail',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/nfdtHashDetail.vue')
    },
    {
        path: '/createAccount',
        name: 'createAccount',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/createAccount.vue')
    },
    {
        path: '/security',
        name: 'security',
        meta: {
            keepAlive: false
        },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/carbon/security.vue')
    },
    
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router